var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeNone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 26 26",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.261 9.557h-5.261v.004 6.878.004h5.261l7.135 4.394v-7.531-.612-7.531z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.34 13.025 2.824-2.824c.393-.393.393-1.028 0-1.421s-1.029-.393-1.422 0l-2.823 2.823-2.823-2.823c-.394-.393-1.029-.393-1.422 0s-.393 1.028 0 1.421l2.823 2.824-2.823 2.823c-.393.393-.393 1.029 0 1.422.195.196.453.294.711.294.257 0 .514-.098.711-.294l2.823-2.824 2.823 2.824c.195.196.453.294.711.294.256 0 .514-.098.711-.294.393-.393.393-1.029 0-1.422z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeNone);
export default __webpack_public_path__ + "static/media/volume_none.0da35b914c86d521355ec6d391202b73.svg";
export { ForwardRef as ReactComponent };